import * as React from 'react';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Dispatch } from 'redux';
import { UserRole } from 'stageclip-common';

import styles from './ClientsUserFormModal.module.scss';
import Button from 'components/buttons/button';
import { SimpleModalId } from 'constants/modalId';
import { ClientsActionTypes } from 'api/clients/clients.action-types';
import {
  BaseDispatchProps,
  baseMapDispatchToProps,
  baseMapStateToProps,
  BaseStateProps,
  ComponentBase,
} from 'components/componentBase';
import FormModal from 'components/modal/formModal';
import { FormId } from 'constants/formId';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import { ClientsUserForm } from './ClientsUserForm';
import { createModalCloseAction, createModalOpenAction } from 'actions/modalActions';
import * as PermissionsHelper from 'helpers/permissionsHelper';

type ClientsUserFormModalStateProps = BaseStateProps;

interface ClientsUserFormModalDispatchProps extends BaseDispatchProps {
  clientId: string;
  role: UserRole.User;
  closeEditUserModal: () => void;
  openDeleteUserModal: () => void;
  userId?: string;
}

interface ClientsUserFormModalComponentOwnProps extends RouteComponentProps<{ id: string }> {
  formTitle: string;
  submitActionType: ClientsActionTypes.ADD_CLIENT_USERS_REQUEST | ClientsActionTypes.EDIT_CLIENT_USER_REQUEST;
  formId: FormId.ClientsUserAdd | FormId.ClientsUserEdit;
  id?: string;
  email?: string;
}

class ClientsUserFormModalComponent extends ComponentBase<
  ClientsUserFormModalComponentOwnProps,
  ClientsUserFormModalStateProps,
  ClientsUserFormModalDispatchProps
> {
  protected loggedInRender() {
    const { clientId } = this.props;

    return (
      <FormModal
        formId={this.props.formId}
        formTitle={this.props.formTitle}
        // @ts-ignore
        submitActionType={this.props.submitActionType}
        buttonIcon={faPlus}
        invertedButtonColours
        initialValues={{
          clientId,
          role: UserRole.User,
        }}
        hideButton={this.props.submitActionType === ClientsActionTypes.EDIT_CLIENT_USER_REQUEST}
      >
        <ClientsUserForm formId={this.props.formId} />
        {PermissionsHelper.userCan(PermissionsHelper.RestrictedActions.DeleteUser) &&
          this.props.formId === FormId.ClientsUserEdit && (
            <div className={styles.buttons}>
              <Button
                type="button"
                className={styles.delete}
                onClick={() => {
                  this.props.closeEditUserModal();
                  this.props.openDeleteUserModal();
                }}
                text="Delete"
                allCapitals
                icon={faTrash}
              />
            </div>
          )}
      </FormModal>
    );
  }
}

const mapStateToProps = (state: ClippingPlatformState): ClientsUserFormModalStateProps => baseMapStateToProps(state);

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: ClientsUserFormModalComponentOwnProps,
): ClientsUserFormModalDispatchProps => {
  const { id } = ownProps.match.params;

  return {
    ...baseMapDispatchToProps(dispatch),
    closeEditUserModal: () => dispatch(createModalCloseAction(FormId.ClientsUserEdit)),
    openDeleteUserModal: () =>
      dispatch(
        createModalOpenAction(SimpleModalId.DeleteUser, {
          id: ownProps.id,
          email: ownProps.email,
        }),
      ),
    clientId: id,
    role: UserRole.User,
  };
};

export const ClientsUserFormModal = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ClientsUserFormModalComponent),
);
